import React from "react";

// react router dom
import { Route, Routes } from "react-router-dom";

// components
import Accounting from "../Accounting/Accounting";
import { Crm } from "../Crm/Crm";
import DashboardApp from "../DashboardApp/DashboardApp";
import ContentUnit from "../ContentController/ContentUnit";
import Management from "../Management/Management";
import Supplier from "../Supplier/Supplier";
import PublicTicketsMenu from "../../components/PublicTicketsMenu/PublicTicketsMenu";
import AddTicket from "../../components/AddTicket/AddTicket";
import TicketsList from "../../components/TicketsList/TicketsList";
import Tickets from "../../components/Tickets/Tickets";
import RollCallUser from "../../components/RollCallUser/RollCallUser";

const Dashboard = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardApp />} />
      <Route path="accounting/*" element={<Accounting />} />
      <Route path="crm/*" element={<Crm />} />
      <Route path="content-controller/*" element={<ContentUnit />} />
      <Route path="management/*" element={<Management />} />
      <Route path="suppliers/*" element={<Supplier />} />
      <Route path="ticket/" element={<PublicTicketsMenu />} />
      <Route path="ticket/AddTicket" element={<AddTicket />} />
      <Route path="ticket/ticketsList" element={<TicketsList publicTicket />} />
      <Route path="tickets/ticketChat/:id" element={<Tickets />} />
      <Route path="RollCall" element={<RollCallUser />} />
    </Routes>
  );
};

export default Dashboard;
